"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceSubscription = replaceSubscription;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
async function replaceSubscription({
  client,
  customerId,
  globalCustomersSubscriptionItemDto,
  subscriptionId,
  subscriptionItemId,
  tenant
}) {
  // TODO -- Is this needed when there is the tenant prop of ApiProvider applied on some upper level?
  const headers = {
    [_fetching.TENANT_CONTEXT]: tenant
  };
  return (0, _globalApiClientReact.updateCustomerSubscriptionSubscriptionItem)(client, customerId, subscriptionId, subscriptionItemId, globalCustomersSubscriptionItemDto, headers);
}
